export function hasPositivePredictedValue(item) {
  if (item == null) return false

  const raw = item.value
  if (raw === null || raw === undefined || raw === '') return false

  const value = typeof raw === 'number' ? raw : parseFloat(String(raw).trim())
  return Number.isFinite(value) && value > 0
}

export function filterPositivePredictedResults(items) {
  return (items || []).filter(hasPositivePredictedValue)
}

export function itemBelongsToGroup(item, groupId) {
  if (!item?.groups?.length || groupId == null) return false
  const target = String(groupId)
  return item.groups.some((id) => String(id) === target)
}
